import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  root: {
    display: "flex",
    alignItems: "center",
    gap: ({ spacing }) => spacing(1),
    padding: ({ spacing }) => spacing(2),
    cursor: "pointer",
    borderRadius: "10px",

    "&:hover": {
      backgroundColor: "primary.dark",
      color: "#000000",
    },
  },
  empty: {
    color: "text.primary",
    textAlign: "center",
  },
};
